import React, { useEffect, useState } from "react";
import moment from "moment";
import "./NotificationBar.scss";

/** Initialize base seconds to countdown.
 *  @param {{message:?string, startTs:Date, endTs:Date, messageType:?string, showTimer:boolean, modifiedBy:?string, modifiedTs:?Date}} message - Message object.
 *  @return {number}*/
const initializeSeconds = message =>
  Math.floor(
    moment.duration(moment(message.endTs).diff(new Date())).asSeconds()
  );

export const NotificationBar = () => {
  const [message] = useState(
    JSON.parse(localStorage.getItem("clavis.system_message"))
  );
  const [seconds, setSeconds] = useState(initializeSeconds(message));

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds <= 0) {
        clearInterval(interval);
        window.dispatchEvent(new CustomEvent("system_message"));
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);
  return (
    <div
      className={`normal-font-medium notification-bar ${
        message.messageType
          ? message.messageType.toLowerCase()
          : "active-inverted-background-color"
      }`}
    >
      {`${message.message}${
        message.showTimer ? " " + moment(seconds * 1000).format("mm:ss") : ""
      }`}
    </div>
  );
};
